module.exports = __webpack_public_path__ + "static/media/inouticon.31c3369c.svg";